import React from 'react';
import {Col, Row} from "react-bootstrap";


function TaetigkeitsberichtHeadings() {
    return (
        <>
            <Row>
                <Col/>
                <Col sm={3}>
                    <label className="handwai-text-label-main">Tätigkeitsbericht</label>
                    {/*
                    <label className="handwai-text-label-main">&nbsp;&nbsp;{taetigkeitsberichtMetaData.date}</label>
*/}
                </Col> <Col/>
                <Col sm={8}/>
            </Row>
            <Row>
                <Col/>
                <Col sm={6}>
                    {/*    <label className="handwai-text-label-normal">Ersteller:</label>
                    <label
                        className="handwai-text-label-normal">&nbsp;&nbsp;
                        {taetigkeitsberichtMetaData.creatorFirstName}
                        {", "}
                        {taetigkeitsberichtMetaData.creatorLastName}
                    </label>
                    <label className="handwai-text-label-normal">&nbsp;&nbsp;{" | "}&nbsp;&nbsp;Akzeptiert:</label>
                    <label className="handwai-text-label-normal">&nbsp;&nbsp;
                        {taetigkeitsberichtMetaData.approvalData.approvalFirstName
                            + ", " + taetigkeitsberichtMetaData.approvalData.approvalLastName}</label>
                    <label className="handwai-text-label-normal">&nbsp;&nbsp;{" am "}&nbsp;&nbsp;
                        {taetigkeitsberichtMetaData.approvalData.approvalDate}</label>*/}
                </Col> <Col/>
                <Col sm={5}/>
            </Row>
        </>
    );
}

export default TaetigkeitsberichtHeadings;
